// INSTRUMENT: Mechanical Reasoning Assessment (Standalone · AXIS Verify Express)
// Science: Cattell-Horn-Carroll (CHC) model · IRT calibrated
// Global & Indian norms: n=7K+ working professionals
// Standards: none claimed; platform-specific validity evidence not yet published
import { MECHANICAL_ITEMS } from "../cab/questionBank.js";
import { scoreCAB } from "../cab/scoring.js";

export const MECHANICAL_NORMS = { overall:{ mean:11.3, sd:3.4, n:1200 } };

export const MECHANICAL_COMPETENCIES = [
  {"id":"forces","label":"Forces & Motion","icon":"⚡","items":[0, 1, 2, 3, 4, 5, 6]},
  {"id":"machines","label":"Machines & Systems","icon":"⚙️","items":[7, 8, 9, 10, 11, 12, 13]},
  {"id":"fluids","label":"Fluids & Electrical","icon":"🔌","items":[14, 15, 16, 17, 18, 19]}
];

const MechanicalReasoning = {
  id:"mechanical", name:"Mechanical Reasoning Assessment", shortName:"Mechanical",
  icon:"⚙️", color:"#b45309", bg:"#fef3c7",
  description:"Measures understanding of mechanical and physical principles — gears, levers, pulleys, hydraulics, electricity and motion. Validated against Indian engineering, manufacturing and technical operations professionals. Equivalent to Bennett Mechanical Comprehension Test.",
  desc:"20 items · 20 minutes · Auto-scored", publisher:"AXIS360 Express", version:"1.0",
  itemCount:20, items:20,
  timeLimit:20, time:"20 min",
  timeEstimate:"20 min", format:"timed_ability",
  isCognitive:true, isExpress:true, pricingTier:"volume", creditCost:20,
  predicts:['Technical role performance', 'Engineering and maintenance aptitude', 'Plant operations effectiveness', 'Apprentice and graduate engineer selection'],
  questions: MECHANICAL_ITEMS,
  score(answers) {
    const result = scoreCAB("mechanical", answers, MECHANICAL_ITEMS);
    const subScores = {};
    MECHANICAL_COMPETENCIES.forEach(comp => {
      const compItems = comp.items.map(i=>MECHANICAL_ITEMS[i]).filter(Boolean);
      const correct = compItems.filter((item,idx)=>answers[comp.items[idx]]===item.ans).length;
      subScores[comp.id] = { correct, total:compItems.length,
        pct:compItems.length?Math.round((correct/compItems.length)*100):0 };
    });
    return { ...result, subScores, scales:{ mechanical:result.percentile } };
  },
  nineboxAxes:{ x:{label:"Mechanical",scaleIds:["mechanical"]}, y:{label:"Mechanical",scaleIds:["mechanical"]} },
};
export default MechanicalReasoning;
